/**
 * Created by rickborst on 14/02/2017.
 */

import {LoginStatus, ActionTypes} from 'store/actions/modals/login';

/**
 * Status logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function status (state = LoginStatus.INITIAL, action) {

    switch (action.type) {

        case ActionTypes.SET_LOGIN_FORM_STATUS:
            return action.status;

        default:
            return state;
    }
}

/**
 * Form data logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function formData (state = {}, action) {

    switch (action.type) {

        case ActionTypes.SET_LOGIN_FORM_DATA:
            return action.initialValues;

        default:
            return state;
    }
}

/**
 * Error logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function getFormError (state = '', action) {

    switch (action.type) {

        case ActionTypes.SET_LOGIN_FORM_ERROR:
            return action.formError || '';

        default:
            return state;
    }
}

/**
 * Login reducer.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Action payload.
 * @returns {Object} Login reducer.
 */
export default function login (state = {}, action) {

    return {
        status: status(state.status, action),
        initialValues: formData(state.initialValues, action),
        formError: getFormError(state.formError, action)
    };
}


// WEBPACK FOOTER //
// ./src/js/store/reducers/modals/login.js